import { FC, PropsWithChildren } from 'react';

import '../table.css';

interface IProps {
  className?: string;
  id?: string;
}

export const TableContainer: FC<PropsWithChildren<IProps>> = ({ children, className, id }) => {
  return (
    <div id={id} className={`table-container ${className}`}>
      {children}
    </div>
  );
};
